import mutations from './generalDocumentTemplate.mutations'
import actions from './generalDocumentTemplate.actions'
import getters from './generalDocumentTemplate.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
